import React from "react";

function ClubSection() {
  return (
    <div className="ClubSection">
      <div className="container">
        <div className="clubInfo text-center">
          <h1
            className="sectionHeading animate__animated animate__fadeInDown"
            data-aos="fade-down"
          >
            <span>SOLSURVIVORS</span>
          </h1>
          <h6 className="mb-3">
            The rich invest in RICH, the poor invest in Bored.
          </h6>
         
          <p className="para">
          🔥 EXCLUSIVE COLLAB WITH SolSurvivors DAO 🔥
          </p>
        </div>
      </div>
    </div>
  );
}

export default ClubSection;
